import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Assets
import mediumNoImage from '/public/SiteImages/medium_no_image.png';
import largeNoImage from '/public/SiteImages/large_no_image.jpeg';

const ListDefaultPhoto = (props) => {

    const [photo, setPhoto] = useState(null);
    const { coverPhoto, listPhotos, className, photoType, bgImage } = props;

    useEffect(() => {
        let activePhoto;
        if (listPhotos != undefined && listPhotos.length > 0) {
            activePhoto = listPhotos[0].name;
            if (coverPhoto != undefined && coverPhoto != null) {
                listPhotos.map((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                })
            }
            setPhoto(activePhoto);
        }
    }, [coverPhoto, listPhotos])


    let path = '', source;
    if (photo != null) {
        source = photo;
        if (photoType != undefined) {
            path = '/images/upload/x_medium_';
        }
    } else {
        if (photoType != undefined) {
            if (photoType === "xx_large") {
                source = largeNoImage;
            } else if (photoType === "x_medium") {
                source = mediumNoImage;
            }
        } else {
            source = mediumNoImage
        }
    }

    if (bgImage) {
        return (
            <div className={className} style={{ backgroundImage: `url(${path}${source})` }}>
                {props.children}
            </div>
        );
    }
    return (
        <img src={path + source} className={className} />
    );
}

ListDefaultPhoto.propTypes = {
    coverPhoto: PropTypes.number,
    listPhotos: PropTypes.array,
    className: PropTypes.string,
    bgImage: PropTypes.bool
};

ListDefaultPhoto.defaultProps = {
    bgImage: false
}

export default ListDefaultPhoto;
